<div class="loader">
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <!-- Pista (anillo estático tenue) -->
    <circle class="track" cx="24" cy="24" r="19" />

    <!-- Spinner (arco giratorio) -->
    <g class="rotate">
      <path class="arc" d="M24 5 A19 19 0 0 1 43 24" />
    </g>

    <!-- Badge VIVO (estático, centro): disco azul + flecha blanca; se ve en cualquier fondo -->
    <!-- Flecha de marca (Manual de marca v1, MDE-579): trazado EXACTO de scripts/generar-marca.cjs.
         La cola termina justo en el borde del disco. Sin clipPath ni id: este componente se pinta
         dos veces (primer y segundo plano) y un id repetido dejaba la cola fuera del disco. -->
    <circle class="disc" cx="24" cy="24" r="12" />
    <path class="mark" d="M32.55 24.63L20.35 31.43A0.72 0.72 0 0 1 19.36 30.47L21.1 27.05A0.72 0.72 0 0 0 20.45 26L12.17 26A12 12 0 0 1 12.17 22L20.45 22A0.72 0.72 0 0 0 21.1 20.95L19.36 17.53A0.72 0.72 0 0 1 20.35 16.57L32.55 23.37A0.72 0.72 0 0 1 32.55 24.63Z" />
  </svg>
</div>
